import { create } from 'zustand'

export interface EventNotification {
  id: string
  type: 'task_created' | 'task_assigned' | 'task_updated' | 'timer_stopped' | 'notification_sent'
  title: string
  description: string
  taskId?: string
  timestamp: number
  dismissed: boolean
}

interface EventNotificationState {
  notifications: EventNotification[]

  addNotification: (notification: Omit<EventNotification, 'timestamp' | 'dismissed'>) => void
  dismiss: (id: string) => void
  dismissAll: () => void
  clearOld: () => void
}

const MAX_NOTIFICATIONS = 20
const TTL_MS = 5 * 60 * 1000 // 5 minutes

export const useEventNotificationStore = create<EventNotificationState>((set) => ({
  notifications: [],

  addNotification: (notification) => {
    const full: EventNotification = {
      ...notification,
      timestamp: Date.now(),
      dismissed: false,
    }
    set((state) => ({
      notifications: [full, ...state.notifications].slice(0, MAX_NOTIFICATIONS),
    }))
  },

  dismiss: (id) => {
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n.id === id ? { ...n, dismissed: true } : n
      ),
    }))
  },

  dismissAll: () => {
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, dismissed: true })),
    }))
  },

  clearOld: () => {
    const cutoff = Date.now() - TTL_MS
    set((state) => ({
      notifications: state.notifications.filter((n) => n.timestamp > cutoff),
    }))
  },
}))
